.kdx-featured-articles {
	padding: 20px 0 0;
	position: relative;
  .pb-4 {
      padding-bottom: 0!important;
  }
	.layout-links {
		display: block;
		text-align: center;
		margin-top: 40px;
		z-index: 3;
		position: relative;

		a {
			margin: 0 20px 0 0;		
		}		
	}

	.featured-articles {
		position: relative;		
	}	
	.kdx-carousel {
        
		.kdx-card { 
			border: none;
			box-shadow: 0 8px 46px rgba(0, 0, 0, .02);
			padding: 5px; 
		}
        &.only-1-item {
            .kdx-hero-slide-item {
                .hero-content { padding-bottom: 24px; }
            }
        }
    }
}




@include media-breakpoint-down(lg) {
	.kdx-featured-articles {

		.featured-articles {
			margin: 0;
			padding: 0;
			width: 100%;
		}
		.kdx-carousel {
			
			&.-cards-slider {
				width: 100%;				
				
				.controls button {
					left: 8px;

					&.right-btn {
						left: auto;
						right: 8px;
					}
				}
			}
		}		
	}
}





@include media-breakpoint-down(sm) {
	.kdx-featured-articles {
		
		.featured-articles {
			margin: 0;
			padding: 0;
			width: 100%;
		}			
		.layout-links {
			display: block;

			a { width: 85%; }
		}
		.kdx-carousel {
			&.-cards-slider {	
				
				&::before, &::after {
					content: '';
					position: absolute;
					top: 0;
					width: 65px;
					height: 100%;
					z-index: 2;
				}
				&::before { 
					left: 0; 
					background: transparent linear-gradient(270deg, #FFFFFF00 0%, #FFFFFFA1 33%, #FFF 100%) 0% 0% no-repeat padding-box;
				}
				&::after { 
					right: 0; 
					background: transparent linear-gradient(90deg, #FFFFFF00 0%, #FFFFFFA1 33%, #FFF 100%) 0% 0% no-repeat padding-box;
				}
				
			}
		}
		.kdx-card .card-img-top { min-height: 227px; }
	}
}
